import { createPlayablePastEventsQuery } from "@api/solid-query/event";
import { LoadingSpinner } from "@components/LoadingSpinner";
import { Show, createEffect, createSignal } from "solid-js";
import { PastEventList } from "./PastEventList";

export const PastEventArea = () => {
  const [page, setPage] = createSignal<number>(0);

  const eventQuery = createPlayablePastEventsQuery({
    page,
  });

  createEffect(() => {
    console.log(
      "events",
      eventQuery.data?.count ?? "NO DATA",
      eventQuery.data?.pageSize,
      showShowMoreButton()
    );
  });

  const loading = () => eventQuery.isLoading;
  const events = () => {
    if (!eventQuery.data) return [];
    return Object.values(eventQuery.data.events).flat();
  };

  const showShowMoreButton = () =>
    (eventQuery.data?.count ?? 0) >
    (page() + 1) * (eventQuery.data?.pageSize ?? 0);

  return (
    <div class="w-full flex flex-col mt-4">
      <div class="w-full flex flex-col md:flex-row px-12">
        <Show when={!loading()} fallback={<LoadingSpinner />}>
          <div class="flex flex-col mt-0 md:mt-0 w-full">
            <div class="flex gap-2 mt-0 flex-col md:flex-row md:w-full md:justify-between md:items-center">
              <h2 class="text-primary font-bold text-3xl">Rally On Demand</h2>
            </div>

            <div class="flex gap-2 mt-2 flex-col md:flex-column md:w-full md:justify-between">
              <h3 class="text-primary font-bold text-xl">
                Missed the Live Event? Ready to Play Again?
              </h3>
              <p class="w-full text-md text-text-black mb-4">
                Experience Riddler Road Rally on your schedule—at a fraction of
                the cost. Play in past rally locations, solve clues on our app,
                navigate the city, and create a live leaderboard by signing up
                with family and friends for the same date and time. Rally On
                Demand doesn’t include the cash jackpot, pre-rally parties, or
                full swag diversions, but it still delivers the ultimate
                challenge for a DIY party, family reunion, or unforgettable
                night out. The adventure is yours to control.
              </p>
            </div>
            <Show
              when={events().length > 0}
              fallback={
                <div class="text-xl mt-4">
                  None yet. Check back soon for some amazing events!
                </div>
              }
            >
              <PastEventList events={events()} />
            </Show>
            <Show when={showShowMoreButton()}>
              <button
                class="btn btn-ghost mt-4"
                onClick={() => setPage(page() + 1)}
                disabled={!eventQuery.data || eventQuery.isLoading}
              >
                Show More
              </button>
            </Show>
          </div>
        </Show>
      </div>
      <div class="flex justify-center mt-12 mb-4">
        <div class="text-primary font-bold text-md">
          Want to plan a private event? Go{" "}
          <a
            href="https://connect.riddlerroadrally.com/private-events"
            class="text-md link italic"
          >
            here
          </a>
        </div>
      </div>
    </div>
  );
};

export default PastEventArea;
